import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "c-location-grid__inner" }

import { computed } from 'vue';
import { RichText, Text as JssText } from '@sitecore-jss/sitecore-jss-vue';
import type { LocationGridItemFields, LocationGridProps } from '@/types/components/LocationGrid';
import type { ScItem } from '@/types/sitecore';
import utils from '@/utils';

interface NormalizedItem extends ScItem<LocationGridItemFields> {
  fields: LocationGridItemFields;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationGrid',
  props: {
    dataSource: {},
    fields: {},
    rendering: {},
    params: {}
  },
  setup(__props: any) {

const props = __props;
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-location-grid'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});

const rawItems = computed<ScItem<LocationGridItemFields>[]>(() => {
  const locationItems = utils.sc.getFieldObj(fields.value, 'items');
  return Array.isArray(locationItems) ? locationItems : [];
});

const items = computed<NormalizedItem[]>(() =>
  rawItems.value.filter((item): item is NormalizedItem => Boolean(item.fields))
);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_ContentGrid = _resolveComponent("ContentGrid")!

  return (fields.value && items.value.length)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(rootClass.value),
        style: _normalizeStyle(rootStyle.value)
      }, [
        _createVNode(_component_ContentGrid, {
          "desktop-default-grid": [1, 22],
          "mobile-default-grid": [1, 14]
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: item.id,
                  class: "c-location-grid__card"
                }, [
                  _createVNode(_component_Icon, {
                    class: "c-location-grid__icon",
                    name: "location"
                  }),
                  (item.fields.title?.value)
                    ? (_openBlock(), _createBlock(_unref(RichText), {
                        key: 0,
                        class: "c-location-grid__title",
                        field: item.fields.title
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true),
                  (item.fields.description?.value)
                    ? (_openBlock(), _createBlock(_unref(RichText), {
                        key: 1,
                        class: "c-location-grid__description",
                        field: item.fields.description
                      }, null, 8, ["field"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ], 6))
    : _createCommentVNode("", true)
}
}

})